export default __webpack_public_path__ + "static/media/Achievements1.aa053997.jpg";